export class WhatsappChat {
    constructor({
                    //attributes
                    client_id= null,
                    user_id= null,
                    company_id= null,
                    data_id= '',
                    phone= '',
                    direction= '',
                    message= '',
                    message_header= '',
                    media_url='',
                    order= 0,
                    timestamp= new Date(),
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                } = {}) {

        //fill attributes
        this.client_id=client_id;
        this.user_id=user_id;
        this.company_id=company_id;
        this.data_id=data_id;
        this.phone=phone;
        this.direction=direction;
        this.message=message;
        this.message_header=message_header;
        this.media_url=media_url;
        this.order=order;
        this.timestamp=new Date(timestamp);
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;

    }
}

export function createWhatsappChat(data={}) {
    return Object.freeze(new WhatsappChat(data));
}